export enum OperatorQueryKey {
	GetMeOperator = 'operator.getme',
	GetUploadCarouselFileUrl = 'operator.getUploadCarouselFileUrl',
	GetUploadPromotionFileUrl = 'operator.getUploadPromotionFileUrl',
	GetUploadRankBannerFileUrl = 'operator.getUploadRankBannerFileUrl',
	GetUploadRankFrameFileUrl = 'operator.getUploadRankFrameFileUrl',
	GetUploadCommissionBannerFileUrl = 'operator.getUploadCommissionBannerFileUrl',
	GetUploadReturnBannerFileUrl = 'operator.getUploadReturnBannerFileUrl',
	GetUploadBannerGameFileUrl = 'operator.getUploadBannerGameFileUrl',
	GetUploadLoginAnnounceFileUrl = 'operator.getUploadLoginAnnounceFileUrl',
	GetUploadLuckyWheelImageFileUrl = 'operator.getUploadLuckyWheelImageFileUrl',
	GetUploadArrowLuckyWheelImageFileUrl = 'operator.getUploadArrowLuckyWheelImageFileUrl',
}
